import { req, withParams } from 'vuelidate/lib/validators/common';

export default (thePattern) => withParams(
  { type: 'pattern', thePattern },
  value => !req(value) || new RegExp(thePattern).test(value)
);



// WEBPACK FOOTER //
// ./src/components/customValidation/pattern.js